import MechanicalSubmission from './MechanicalSubmission';

export default MechanicalSubmission;
